import P2PDebitScreen from 'features/moveMoney/screens/P2P/P2pDebitScreen';
import React from 'react';

export default function P2PDebitPage() {
  return <P2PDebitScreen />;
}
